import { motion } from "framer-motion";
import { SectionHeading, SectionLabel } from "./Section";

const cards = [
  {
    n: "01",
    title: "Competitive Discipline",
    body: "Months of preparation taught me how to attack difficult problems systematically.",
  },
  {
    n: "02",
    title: "Self-Taught Learning",
    body: "I actively learn emerging technologies rather than waiting for formal instruction.",
  },
  {
    n: "03",
    title: "Founder Mindset",
    body: "I am interested in building systems, products, and businesses that create long-term value.",
  },
];

export function Mindset() {
  return (
    <section className="relative py-32">
      <div className="mx-auto max-w-7xl px-6">
        <div className="mb-16 max-w-2xl">
          <SectionLabel>Operating system</SectionLabel>
          <SectionHeading>How I Think</SectionHeading>
        </div>

        <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
          {cards.map((c, i) => (
            <motion.div
              key={c.n}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.1 }}
              className="group relative overflow-hidden rounded-2xl border border-white/[0.06] bg-gradient-to-b from-white/[0.04] to-transparent p-8 transition-all hover:border-white/15"
            >
              <div className="absolute -right-12 -top-12 h-40 w-40 rounded-full bg-electric/10 blur-3xl opacity-0 transition-opacity duration-700 group-hover:opacity-100" />
              <div className="text-electric-gradient text-sm font-mono tracking-wider">{c.n}</div>
              <h3 className="mt-6 text-2xl font-semibold tracking-tight">{c.title}</h3>
              <p className="mt-4 text-muted-foreground">{c.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
